import { useContext } from 'react';
import { ToastContext } from '@/context/ToastProvider';
import { ToastData } from '@/context/ToastProvider/types';
import { useTimeout } from '@/hooks/useTimeout';

export const useToast = () => {
  const methods = useContext(ToastContext);
  const addTimeout = useTimeout();

  const add = (toast: ToastData) => {
    const id = methods.addToast(toast);
    addTimeout(() => methods.removeToast(id), toast.timeout ?? 6000);
  };

  return { add, toasts: methods.toasts };
};
